import React, { useEffect, useMemo, useState } from 'react';
import arrowDown from '../../static/images/svg/arrow-down.svg';
import Select from 'react-select';
import STATUSES from '../../i18n/statuses';
import LoadingDots from "../../components/ui/LoadingDots";
import FormattedMessage from "../../i18n/FormattedMessage";
import { getDefaultI18nMessage } from "../../i18n";
import {confirmDialog} from 'primereact/confirmdialog';
import {history} from '../../store';
import {getForms} from '../../actions';

const PageList = (props) => {
  const { language, router,
    getCompany,
    formTypes,
    createRequest, getRequest, deleteRequest,
    forms,
    loaders,
    companies,
    orn,
    setORN
  } = props;

  // if ((!orn || orn === 0) && (companies && companies.length === 1)) {
  //   if (companies[0].orn && Number(orn) > 0) orn = companies[0].orn;
  // }

  const [sort, setSort] = useState({
    sortBy: 'id',
    sortTo: 'desc',
  });

  const setListSort = by => {
    if (by === sort.sortBy && sort.sortTo !== 'asc') {
      setSort({ sortBy: by, sortTo: 'asc' });
    } else {
      setSort({ sortBy: by, sortTo: 'desc' });
    }
  };

  const [ selectedRequest, setSelectedRequest ] = useState(null);

  const list = [...forms || []]
    .sort((a,b)=>{
      if (sort.sortTo === 'desc') {
        if (sort.sortBy === 'sent_date') {
          return new Date(b[sort.sortBy]) - new Date(a[sort.sortBy]);
        } else if (sort.sortBy === 'request_type_id') {
          const aLabel = formTypes.filter(type => type.id === a.request_type_id)[0][`full_type_name_${language}`];
          const bLabel = formTypes.filter(type => type.id === b.request_type_id)[0][`full_type_name_${language}`];
          return aLabel.localeCompare(bLabel);
        } else if (sort.sortBy === 'status') {
          return a[sort.sortBy].localeCompare(b[sort.sortBy]);
        } else {
          return b[sort.sortBy] - a[sort.sortBy];
        }
      } else {
        if (sort.sortBy === 'sent_date') {
          return new Date(a[sort.sortBy]) - new Date(b[sort.sortBy]);
        } else if (sort.sortBy === 'request_type_id') {
          const aLabel = formTypes.filter(type => type.id === a.request_type_id)[0][`full_type_name_${language}`];
          const bLabel = formTypes.filter(type => type.id === b.request_type_id)[0][`full_type_name_${language}`];
          return bLabel.localeCompare(aLabel);
        } else if (sort.sortBy === 'status') {
          return b[sort.sortBy].localeCompare(a[sort.sortBy]);
        } else {
          return a[sort.sortBy] - b[sort.sortBy];
        }
      }
    });

  const sendRequest = () => {
    createRequest(selectedRequest.value, orn);
    router.push(`/residents/create`);
  };
  const openRequest = (id) => {
    getRequest(id);
    router.push(`/residents/${id}/`);
  };

  const showComment = request => {
    confirmDialog({
      message: request['status_comment'],
      header: 'Комментарий',
      accept: null,
      reject: null,
      acceptLabel: 'Ок',
      rejectLabel: ' ',
    });
  };

  const values = formTypes && formTypes.map(value => {
    return { value: value.type_id_slug, label: value[`full_type_name_${language}`] }
  });

  const onChange = value => {
    setSelectedRequest(value);
  };

  const setCompany = value => {
    const orn = value.value;
    if (Number(orn) > 0) {
      getCompany(orn);
    }
  };

  const status = id => {
    return STATUSES[id]
      ? STATUSES[id][language]
        ? { title: STATUSES[id][language], id }
        : { title: id, id }
      : { title: id, id };
  };

  const onClick = elem => {
    openRequest(elem.id);
    return;
  };

  const downloadRequest = url => {
    if (url) {
      window.open(url);
    }
  };

  const itemClass = elem => {
    if (elem.status === 'draft' && !elem.is_locked) return '';
    else if (elem.latest_asu_file) return '';
    return 'disabled';
  };

  let currentCompany, selectedOption = null;

  if (orn && companies && companies.filter(company => company.orn === orn)[0]) {
    currentCompany = companies.filter(company => company.orn === orn)[0];
    selectedOption = {value: orn, label: currentCompany.name};
  }

  return(
    <>
      <article>
        {/*  Page Content */}
        <h1 className="title-snall title-snall-3 page-title"><FormattedMessage id={props.route.path} /></h1>
        <div className="hr-line" />
          <LoadingDots show={!!loaders['requests']}>
            {companies && companies.length > 0 ? (
              <Select className='companySelect'
                      isClearable={false}
                      hideSelectedOptions={true}
                      options={companies.map(company => ({value: company.orn, label: company.name }))}
                      value={selectedOption}
                      placeholder={getDefaultI18nMessage('select_company', language)}
                      onChange={event => setCompany(event)}
              />
            ) : (
              (!values || values.length === 0) && <div className="request-list__info">
                <FormattedMessage id="no_company" />
              </div>
            )}
            {values.length > 0 && (
              <>
                <Select className='requestSelect'
                        options={values}
                        value={selectedRequest}
                        placeholder={getDefaultI18nMessage('select_request_type', language)}
                        onChange={event => onChange(event)}
                />
                <button className="btn btn--blue" onClick={sendRequest} disabled={!selectedRequest}>
                  <FormattedMessage id="create_request" />
                </button>
              </>
            )}

            {list && list.length > 0 && (
              <>
              <div className="hr-line" />
              <h2 className="title-snall title-snall-2">
                <FormattedMessage id="current_request" />
              </h2>
              <table className="table custom-table request-list">
              <thead className="request-list__header">
                <tr>
                  <th className="request-list__header-item sortable" onClick={()=>setListSort('id')}>
                    <FormattedMessage id="request_number" />&nbsp;
                    {sort.sortBy === 'id' && (
                      <span className="sort-arrow">
                        <img
                          alt="sort"
                          className={sort.sortTo === 'desc' ? 'rotated' : ''}
                          src={arrowDown}
                        />
                      </span>
                    )}
                  </th>
                  <th className="request-list__header-item sortable" onClick={()=>setListSort('sent_date')}>
                    <FormattedMessage id="request_date" />&nbsp;
                    {sort.sortBy === 'sent_date' && (
                      <span className="sort-arrow">
                        <img
                          alt="sort"
                          className={sort.sortTo === 'desc' ? 'rotated' : ''}
                          src={arrowDown}
                        />
                      </span>
                    )}
                  </th>
                  <th className="request-list__header-item sortable" onClick={()=>setListSort('request_type_id')}>
                    <FormattedMessage id="request_type" />&nbsp;
                    {sort.sortBy === 'request_type_id' && (
                      <span className="sort-arrow">
                        <img
                          alt="sort"
                          className={sort.sortTo === 'desc' ? 'rotated' : ''}
                          src={arrowDown}
                        />
                      </span>
                    )}
                  </th>
                  <th className="request-list__header-item sortable" onClick={()=>setListSort('status')}>
                    <FormattedMessage id="request_status" />&nbsp;
                    {sort.sortBy === 'status' && (
                      <span className="sort-arrow">
                        <img
                          alt="sort"
                          className={sort.sortTo === 'desc' ? 'rotated' : ''}
                          src={arrowDown}
                        />
                      </span>
                    )}
                  </th>
                  <th className="request-list__header-item" />
                </tr>
              </thead>
              <tbody className="request-list__body" >
                {list.map((val) => {
                                // TODO: refactor
                  const formatter = new Intl.DateTimeFormat("ru",{
                                                    day: "numeric",
                                                    month: "numeric",
                                                    year: "numeric",
                                                  });
                  const disabled = val['is_locked'];
                  const isCommented = val['request_result'] === false && val['status_comment'] && val['status_comment'].length > 0;
                  // console.log('REQUEST', val.asu_files);

                  return (
                  <tr key={val.id} className={`request-list__item`} >
                    <td className="request-list__item-data" onClick={ () => onClick(val) }>
                      {val.id}
                    </td>
                    <td className="request-list__item-data" onClick={ () => onClick(val) }>
                      {!!val.sent_date && formatter.format(new Date(val.sent_date))}
                    </td>
                    <td className="request-list__item-data" onClick={ () => onClick(val) }>
                      <span>{formTypes && formTypes.filter(type => type.id === val['request_type_id']).length === 1 && formTypes.filter(type => type.id === val['request_type_id'])[0][`full_type_name_${language}`]}</span>
                    </td>
                    <td className="request-list__item-data uppercase" onClick={ () => onClick(val) }>
                      <span className="adrow-title">Статус:&nbsp;</span>
                      <span className={`label ${(status(val.status) && status(val.status).id) ? status(val.status).id : 'label-primary' }`}>
                        {val.status}
                      </span>
                    </td>
                    <td className="request-list__item-actions">
                      {isCommented && <button className={`info-button`} onClick={() => showComment(val)} />}
                      {!disabled && <button className={`edit-button`} onClick={ () => openRequest(val.id) } />}
                      {!val.is_locked && <button className='remove-button' onClick={ () => deleteRequest(val.id) } />}
                      {val.asu_files.length > 0 && val.asu_files.map((file, key) => {
                        return (
                          <button className={`download-button ${file.name.lastIndexOf('.') > -1 ? file.name.substr(file.name.lastIndexOf('.')+1) : 'default'}`}
                                  key={key}
                                  onClick={() => downloadRequest(file.file_url)}
                                  title={`${getDefaultI18nMessage('download_file', language)} ${file.name.lastIndexOf('.') > -1 ? file.name.substr(file.name.lastIndexOf('.')+1) : ''}`}
                          />
                        )
                      })}
                    </td>
                  </tr>
                )})}
              </tbody>
            </table>
            </>
            )}
          </LoadingDots>
      </article>
    </>
  )
};

export default PageList;
